var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('a',{staticClass:"FooterDonation",class:_vm.classObject,attrs:{"href":_vm.settings.donation_link.url}},[_vm._v(_vm._s(_vm.settings.donation_link.title)),_c('SvgInline',{attrs:{"src":"extern"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }